<template>
  <div>
    <div class="resource-category-edit-form setting-form">
      <el-row :gutter="20">
        <el-col :md="8">
          <div class="setting-cell">
            <category-list
              ref="categoryList"
              @change="onChangeCategory"/>
          </div>
        </el-col>
        <el-col :md="16">
          <template v-if="parentMembershipsInCategory.length === 0">
            <div class="setting-cell">
              <div class="header">
                {{ categoryName }}
              </div>
              <div class="empty-message">
                <div>
                  <warning-message message="등록된 회원권이 없습니다."/>
                  <el-button
                    class="black"
                    @click="handleClickAddMembership">
                    회원권 등록
                  </el-button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="setting-cell">
              <div class="header">
                {{ categoryName }}
              </div>
              <membership-item
                v-for="membership in parentMembershipsInCategory"
                :key="membership.id"
                :data="membership"
                @modify="handleClickModifyMembership"
                @delete="handleClickDeleteCourse"
              />
            </div>
            <div class="course-controller">
              <el-button
                class="black float-md-left float-right"
                @click="handleClickAddMembership">
                회원권 추가
              </el-button>
            </div>
          </template>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import CategoryList from "./ParentMembershipCategory/CategoryList.vue";
  import WarningMessage from "@/components/element-ui/WarningMessage";
  import MembershipEditForm from "./MembershipEditForm";
  import MembershipItem from "./MembershipItem";
  import { fiflboxApi } from '@/utils/api';

  export default {
    name: "Membership",
    components: {
      MembershipItem,
      MembershipEditForm,
      WarningMessage,
      CategoryList,
    },
    props: ["page"],
    data() {
      return {
        editingCourse: null,
        isEditing: false,
        memberships: [],
        category: {
          id: null,
          name: "",
        },
        instructors: {},
        categoryName: "",
        activeCategoryId: null
      };
    },
    computed: {
      parentMembershipsInCategory() {
        const category = this.$store.getters.getParentMembershipCategory(this.activeCategoryId);

        if (!category || category.parent_memberships.length === 0) {
          return []
        }

        return category.parent_memberships
      }
    },
    methods: {
      handleClickAddMembership() {
        this.$router.push('/setting/membership/create').catch(()=>{})
      },
      handleClickModifyMembership(membership) {
        this.$router.push("/setting/membership/" + membership.id).catch(()=>{})
      },
      async handleClickDeleteCourse(form) {
        try {
          await this.$confirm(
            "리스트에서만 삭제되며 현재 본 회원권을 이용 중인 회원은 계속해서 이용하실 수 있습니다.",
            "회원권 삭제",
            {
              confirmButtonText: "확인",
              cancelButtonText: "취소",
            }
          );
        } catch (err) {
          return;
        }

        await fiflboxApi.v1.deleteParentMemberships(form.id);

        this.$message("회원권이 삭제됐습니다");
        await this.$store.dispatch("syncParentMembershipCategories");
      },
      async onChangeCategory(category) {
        this.categoryName = category.name;
        this.activeCategoryId = category.id;

      },
    },
  };
</script>

<style lang="scss">
  .resource-category-edit-form {
    .setting-cell {
      border-radius: 6px;
      background-color: #ffffff;
      box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
      padding: 20px;

      .header {
        height: 27px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: -0.6px;
        color: #4a4a4a;
        border-bottom: solid 1px #d3d3d3;
        margin-bottom: 8px;
      }
    }

    .course-controller {
      margin: 10px 20px;
    }

    .empty-message {
      min-height: 350px;

      & > div {
        text-align: center;

        .warning-message-container {
          margin-bottom: 30px;
        }
      }
    }
  }
</style>
